import React from 'react';
import { renderToString } from 'react-dom/server';
import { onPageLoad } from 'meteor/server-render';
import { StaticRouter } from 'react-router';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Helmet } from 'react-helmet';
import { ServerStyleSheet } from 'styled-components';
import { Meteor } from 'meteor/meteor';
import App from '../both/App';
import mainReducer from '../../modules/redux/reducers';
// import parseUrlForSsr from '../../modules/parse-url-for-ssr';

const { googleAnalyticsKey } = Meteor.settings.private;
onPageLoad(sink => {
  // const rpaURL = parseUrlForSsr(sink.request.url, 'rpas');

  const context = {};
  const data = {
    loading: true,
    loggingIn: false,
    authenticated: false,
    name: '',
    roles: [],
    userId: null,
    emailAddress: '',
    emailVerified: false
    // rpa: rpaURL.isMatch ? Meteor.call('rpas.findOne', rpaURL.parts[2]) : ''
  };
  const store = createStore(mainReducer, data, applyMiddleware(thunk));
  const initialData = store.getState();
  const stylesheet = new ServerStyleSheet();

  const app = renderToString(
    stylesheet.collectStyles(
      // eslint-disable-line
      <Provider store={store}>
        <StaticRouter location={sink.request.url} context={context}>
          <App />
        </StaticRouter>
      </Provider>
    )
  );

  const helmet = Helmet.renderStatic();
  sink.appendToHead(helmet.meta.toString());
  sink.appendToHead(helmet.title.toString());
  sink.appendToHead(stylesheet.getStyleTags());

  sink.renderIntoElementById('react-root', app);

  sink.appendToBody(`
    <script>
      window.__PRELOADED_STATE__ = ${JSON.stringify(initialData).replace(/</g, '\\u003c')}
    </script>

      <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsKey}"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', '${googleAnalyticsKey}');
  </script>
  `);
});
